import axios from 'axios';

//const BASE_URL = `${process.env.REACT_APP_HOST_URL}:${process.env.REACT_APP_BACKEND_PORT}`;
const getBaseUrl = () => {
    return process.env.REACT_APP_HOST_URL;
}

// const BASE_URL = `https://api.spsf.trackonomysystems.com/facility-ext`;

// Data coming from tapecfgDb . Hence naming associated in the variable.
// To Do: Will create resuable functiions 
// To Do: Should add Unit test as well as a future model for code enhancements
export const getAssociatedFacilities = async (page = 1, limit = 10, filters = {}) => {
    try {
        const response = await axios.get(`${getBaseUrl()}/associatedfacilities`, {
            params: { page, limit, ...filters }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching facilities:', error);
        return { data: [], pagination: {} };
    }
};

export const getAssociatedFacilityOptions = async () => {
    try {
        const response = await axios.get(`${getBaseUrl()}/facilities/filters/associatedfacilities`);
        return response.data;
    } catch (error) {
        console.error("Error fetching TapeID options:", error);
        throw error;
    }
};

export const updateAssociatedFacility = async (id, facility) => {
    try {
        await axios.put(`${getBaseUrl()}/updatefacility`, { facility },
            {
                params: { id },
            });
    } catch (error) {
        console.error('Error updating facility:', error);
        throw error;
    }
};

